define(["./automaticFlowsModule"], function (module) {
    "use strict";

    return module.controller("automaticFlowsController", [
        "$scope",
        "loadingService",
        "mbrService",
        "monitoringService",
        "messagesModal",
        function ($scope, loadingService, mbrService, monitoringService, messagesModal) {
            $scope.automaticFlows = {};

            loadingService(monitoringService.getAutomaticFlowsConfigurations()
                .then(function (response) {
                    $scope.automaticFlows = response.data
                    $scope.getOccurrencesCauses(response.data)

                }))

            $scope.getOccurrencesCauses = (occurrences) => {
                $scope.active = true
                $scope.occurrencesCauses = {
                    cancel: {
                        find: monitoringService.findOccurrenceCauses,
                        current: occurrences.automaticCancelMonitoring.occurrenceCause,
                    },
                    finish: {
                        find: monitoringService.findOccurrenceCauses,
                        current: occurrences.automaticFinishMonitoring.occurrenceCause,
                    },
                    delay: {
                        find: monitoringService.findOccurrenceCauses,
                        current: occurrences.delayOccurrenceConfigurations.occurrenceCause,
                        categories: {
                            find: monitoringService.findOccurrenceCategories,
                            current: $scope.getOccurrenceCategory(occurrences.delayOccurrenceConfigurations.occurrenceCause),
                        }
                    },
                    velocity: {
                        find: monitoringService.findOccurrenceCauses,
                        current: occurrences.velocityOccurrenceConfigurations.occurrenceCause,
                        categories: {
                            find: monitoringService.findOccurrenceCategories,
                            current: $scope.getOccurrenceCategory(occurrences.velocityOccurrenceConfigurations.occurrenceCause),
                        }
                    },
                }
            }

            $scope.calculateVelocityType = [
                "br.com.neolog.monitoring.automatic.flows.model.api.CalculateVelocityType.PARAMETER",
                "br.com.neolog.monitoring.automatic.flows.model.api.CalculateVelocityType.SIGNAL"
            ]

            $scope.getOccurrenceCategory = (occurrenceCause) => {
                if (!occurrenceCause) {
                    return null
                }
                return occurrenceCause.occurrenceCategory
            }

            $scope.formatTag = function (tag) {
                if (tag) {
                    return tag.name
                }
            }

            $scope.changeOccurrenceCategory = (model) => {
                if (!model.categories.current) {
                    model.current = null;
                }
            }

            function getOccurrenceCause(occurrenceCause) {
                if (!occurrenceCause) {
                    return null
                }
                return occurrenceCause;
            }


            $scope.isParameterCalculateVelocityType = (model) => {
                if(!model){
                    return false;
                }
                return model === "br.com.neolog.monitoring.automatic.flows.model.api.CalculateVelocityType.SIGNAL"
            }

            function getBody() {
                let automaticFlows = $scope.automaticFlows;
                let occurrencesCauses = $scope.occurrencesCauses;
                automaticFlows.automaticCancelMonitoring.occurrenceCause = getOccurrenceCause(occurrencesCauses.cancel.current)
                automaticFlows.automaticFinishMonitoring.occurrenceCause = getOccurrenceCause(occurrencesCauses.finish.current)
                automaticFlows.delayOccurrenceConfigurations.occurrenceCause = getOccurrenceCause(occurrencesCauses.delay.current)
                automaticFlows.velocityOccurrenceConfigurations.occurrenceCause = getOccurrenceCause(occurrencesCauses.velocity.current)
                return automaticFlows;
            }
            
            $scope.isValidResult = function (elements) {
                var messages = [];
                elements.forEach((function (element) {
                    if (element.result === false) {
                        messages.push(element.description)
                    }
                }));
                return messages
            };

            $scope.save = function () {
                let automaticFlows = getBody();
                loadingService(monitoringService.saveAutomaticFlowsConfigurations(automaticFlows))
                    .then((result) => {
                        var messages = $scope.isValidResult(result.data);
                        if (messages.length < 1) {
                            messagesModal("dialog.success", [{
                                keyBundle: "automaticFlows.message.success",
                                parameters: []
                            }]);
                            return;
                        }
                        messagesModal("dialog.error", messages);
                    })
            };


        }]);
});